import { useMutation } from '@tanstack/react-query';

import { UserInteraction } from '../models';
import { $apiWithoutClient } from '../service';

export const useUserInteraction = () =>
  useMutation({
    mutationFn: async ({ universityId, action }: { universityId?: string; action?: UserInteraction }) => {
      const { data } = await $apiWithoutClient.post('/user-interaction/store', {
        university_id: universityId,
        action
      });

      return data;
    }
  });
